import { IGPKeyInitiative } from 'legacy/lut/classes/models/partner360/IGPKeyInitiative'
import { mapPersistedDescriptionQualityToResult } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/descriptionQuality/mappers'
import { TInvestmentSourceValue } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/investmentSource/models'
import { IGPKeyInitiativeForm } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/gpKeyInitiatives/components/partnerView/components/gpKeyInitiativesEditor/models/gpKeyInitiativeForm'

import { normalizeKeyInitiativeStatus } from 'partner360/entities/keyInitiatives/model/status'

export const mapGPKeyInitiativeToForm = (data: Partial<IGPKeyInitiative>) => {
  const form: IGPKeyInitiativeForm = {
    entryId: data.EntryId,
    previousEntryId: data.PreviousEntryId ?? null,
    name: data.Name || '',
    businessUnit: data.BusinessUnit || '',
    description: data.Description || '',
    descriptionQuality: mapPersistedDescriptionQualityToResult(data.DescriptionQuality),
    focusArea: data.FocusArea || '',

    currency: data.Currency || '',
    activityType: data.ActivityType || '',

    goalNdp: data.GoalNdp || 0,
    goalNdpUsd: data.GoalNdpUSD || 0,
    goalNdpLocalCurrency: data.GoalNdpLocalCurrency || 0,
    goalNet: data.GoalNet || 0,
    goalNetUsd: data.GoalNetUSD || 0,
    goalNetLocalCurrency: data.GoalNetLocalCurrency || 0,
    goalTNet: data.GoalTNet || 0,
    goalTNetUsd: data.GoalTNetUSD || 0,
    goalTNetLocalCurrency: data.GoalTNetLocalCurrency || 0,
    goalUTNet: data.GoalUTNet || 0,
    goalUTNetUsd: data.GoalUTNetUSD || 0,
    goalUTNetLocalCurrency: data.GoalUTNetLocalCurrency || 0,

    incrementalNdp: data.IncrementalNdp || 0,
    incrementalNdpUsd: data.IncrementalNdpUSD || 0,
    incrementalNdpLocalCurrency: data.IncrementalNdpLocalCurrency || 0,
    incrementalNet: data.IncrementalNet || 0,
    incrementalNetUsd: data.IncrementalNetUSD || 0,
    incrementalNetLocalCurrency: data.IncrementalNetLocalCurrency || 0,
    incrementalTNet: data.IncrementalTNet || 0,
    incrementalTNetUsd: data.IncrementalTNetUSD || 0,
    incrementalTNetLocalCurrency: data.IncrementalTNetLocalCurrency || 0,
    incrementalUTNet: data.IncrementalUTNet || 0,
    incrementalUTNetUsd: data.IncrementalUTNetUSD || 0,
    incrementalUTNetLocalCurrency: data.IncrementalUTNetLocalCurrency || 0,

    hpInvestmentSource: data.HPInvestmentSource || ('' as TInvestmentSourceValue),
    hpInvestmentSum: data.HPInvestmentSum || 0,
    isDataInsightRelated: data.DataInsightRelated === 1,
    keyObjective: data.Development || '',
    keyObjectiveTags: data.KeyObjectiveTags?.split(',') || [],
    owner: data.Owner || '',
    period: data.Period?.split(',') || [],
    shouldAddToBridges: data.AddToBridges === 1,
    status: normalizeKeyInitiativeStatus(data.Status) || '',
    valueType: data.ValueType || '',

    initType: data.InitType || null,
    isAchieved: typeof data.IsAchieved === 'number' ? data.IsAchieved === 1 : null,
    goalDescription: data.GoalDescription || '',
    proofOfExecution: data.ProofOfExecution || '',

    countriesAffectedList: data.CountriesAffectedList?.split(',') || [],
    isCountriesAffected: Boolean(data.IsCountriesAffected),
  }

  if (data.HPInvestmentSum !== null && data.HPInvestmentSource !== null) {
    form.hpInvestmentSource = data.HPInvestmentSource
    form.hpInvestmentSum = data.HPInvestmentSum
  }

  return form
}
